import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toaster } from '@/components/ui/toaster';
import api from '@/libs/axiosInstance';
import type { PaymentMethod } from '@/types/payment-method';

interface AddBrandPaymentMethodPayload {
  stripePaymentMethodId: string;
}

const addBrandPaymentMethod = async (
  payload: AddBrandPaymentMethodPayload
): Promise<PaymentMethod> => {
  const response = await api.post<PaymentMethod>('/dashboard/payment-methods', payload);
  return response.data;
};

export const useAddBrandPaymentMethodAction = () => {
  const queryClient = useQueryClient();

  return useMutation<PaymentMethod, Error, AddBrandPaymentMethodPayload>({
    mutationFn: addBrandPaymentMethod,
    onSuccess: (data) => {
      // Invalidate the payment methods query to refetch the updated list
      queryClient.invalidateQueries({ queryKey: ['brandPaymentMethods'] });
      console.log('Successfully added payment method:', data);
      toaster.success({
        title: 'Payment method added',
        description: 'Payment method added successfully',
      });
    },
    onError: (error) => {
      console.error('Failed to add payment method:', error);
      toaster.error({
        title: 'Failed to add payment method',
        description: error.message,
      });
    },
  });
};
